import { render, staticRenderFns } from "./FormRatesVarCube.vue?vue&type=template&id=b8b194f6&scoped=true&"
import script from "./FormRatesVarCube.vue?vue&type=script&lang=js&"
export * from "./FormRatesVarCube.vue?vue&type=script&lang=js&"
import style0 from "./FormRatesVarCube.vue?vue&type=style&index=0&id=b8b194f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b194f6",
  null
  
)

export default component.exports